import BoxLoader from "./BoxLoader";
export default BoxLoader;